import { FormEvent } from 'react'
import { useParams } from 'react-router'
import { useAccountRoleGet, useAccountRoleUpdate } from '../api/account-roles'
import { AccountRolesForm } from './account-roles-form'

export function AccountRolesEdit() {
	const { id } = useParams()
	const { data, isSuccess, dataUpdatedAt } = useAccountRoleGet(id as string)
	const { mutate, isPending } = useAccountRoleUpdate(id as string)

	const onSubmit = (event: FormEvent<HTMLFormElement>) => {
		const form = event.currentTarget
		event.preventDefault()
		mutate(new FormData(form))
	}

	if (!isSuccess) return null

	return (
		<AccountRolesForm
			key={dataUpdatedAt}
			onSubmit={onSubmit}
			isPending={isPending}
			data={data}
		/>
	)
}
